import { useEffect, useRef } from "react";

/** Digit boxes: auto-advance, backspace, paste; a hidden-feel single input per box with iOS one-time-code autofill on the first. */
export const OtpBoxes = ({ value, onChange, length = 6, onComplete, testid = "auth-otp" }) => {
  const refs = useRef([]);
  const digits = Array.from({ length }, (_, i) => value[i] || "");
  useEffect(() => { refs.current[0]?.focus(); }, []);
  const set = (next) => { const v = next.replace(/\D/g, "").slice(0, length); onChange(v); if (v.length === length) onComplete?.(v); };
  const onInput = (i, e) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (raw.length > 1) { set(value.slice(0, i) + raw); refs.current[Math.min(length - 1, i + raw.length)]?.focus(); return; } // paste / autofill
    const v = (value.slice(0, i) + raw + value.slice(i + 1)).slice(0, length);
    set(v);
    if (raw && i < length - 1) refs.current[i + 1]?.focus();
  };
  const onKey = (i, e) => {
    if (e.key === "Backspace" && !digits[i] && i > 0) { refs.current[i - 1]?.focus(); set(value.slice(0, i - 1)); e.preventDefault(); }
    if (e.key === "ArrowLeft" && i > 0) refs.current[i - 1]?.focus();
    if (e.key === "ArrowRight" && i < length - 1) refs.current[i + 1]?.focus();
  };
  const onPaste = (e) => { e.preventDefault(); set((e.clipboardData.getData("text") || "")); refs.current[Math.min(length - 1, value.length)]?.focus(); };
  return (
    <div className="otp-boxes notranslate" translate="no" onPaste={onPaste} data-testid={`${testid}-boxes`}>
      {digits.map((d, i) => (
        <input key={i} ref={(el) => (refs.current[i] = el)} className="otp-box" value={d} inputMode="numeric" pattern="[0-9]*"
          autoComplete={i === 0 ? "one-time-code" : "off"} aria-label={`Digit ${i + 1}`} onChange={(e) => onInput(i, e)} onKeyDown={(e) => onKey(i, e)}
          onFocus={(e) => e.target.select()} data-testid={`${testid}-box-${i}`} />
      ))}
    </div>
  );
};
